// ###### IMPORTS
import React from 'react';
import CardCalendars from './viewComponents/CardCalendars';
import CardGeneralOptions from './viewComponents/CardGeneralOptions';
import CardGoogleCalendar from './viewComponents/CardGoogleCalendar';

// ###### MAIN COMPONENT
const TabPlannerSettings = ({
  calendars,
  isCalendarsLoading,
  onCalendarCreate,
  onCalendarUpdate,
  onCalendarDelete,
  fadePastEvents = true,
  onFadePastEventsChange,
  weekRowsVisible = 6,
  onWeekRowsVisibleChange,
  timeFormatPreference = '24h',
  onTimeFormatPreferenceChange,
  refreshCalendars,
  refreshEvents,
}) => {
  return (
    <div className="p-0 flex flex-col gap-2 w-full mt-2">
      <CardGeneralOptions
        fadePastEvents={fadePastEvents}
        onFadePastEventsChange={onFadePastEventsChange}
        weekRowsVisible={weekRowsVisible}
        onWeekRowsVisibleChange={onWeekRowsVisibleChange}
        timeFormatPreference={timeFormatPreference}
        onTimeFormatPreferenceChange={onTimeFormatPreferenceChange}
      />
      <CardGoogleCalendar
        calendars={calendars}
        refreshCalendars={refreshCalendars}
        refreshEvents={refreshEvents}
      />
      <CardCalendars
        calendars={calendars}
        isLoading={isCalendarsLoading}
        onCreateCalendar={onCalendarCreate}
        onUpdateCalendar={onCalendarUpdate}
        onDeleteCalendar={onCalendarDelete}
        refreshCalendars={refreshCalendars}
        refreshEvents={refreshEvents}
      />
    </div>
  );
};

export default TabPlannerSettings;
